import { z } from 'zod';
import { ROLE_PRESETS } from './roles.js';

/**
 * Convite para servir: é assim que o voluntário ganha acesso ao aplicativo
 * (M01 e M02). Sem ele, a escala publicada não chega a ninguém.
 */

export const INVITE_STATUS = ['PENDING', 'ACCEPTED', 'REVOKED', 'EXPIRED'] as const;
export const inviteStatusSchema = z.enum(INVITE_STATUS);
export type InviteStatus = z.infer<typeof inviteStatusSchema>;

export const INVITE_STATUS_LABEL: Record<InviteStatus, string> = {
  PENDING: 'Aguardando aceite',
  ACCEPTED: 'Conta criada',
  REVOKED: 'Cancelado',
  EXPIRED: 'Expirado',
};

export const createInviteSchema = z.object({
  email: z.string().trim().toLowerCase().email('Informe um e-mail válido'),
  name: z.string().trim().min(3, 'Informe o nome').max(160),
  roleSlug: z
    .enum(ROLE_PRESETS.map((papel) => papel.slug) as [string, ...string[]])
    .default('volunteer'),
  /** Cadastro que a conta assume ao aceitar — é o que liga login e escala. */
  personId: z.string().uuid().nullish(),
});
export type CreateInviteInput = z.infer<typeof createInviteSchema>;

export const inviteSchema = z.object({
  id: z.string().uuid(),
  email: z.string(),
  name: z.string().nullable(),
  roleName: z.string(),
  personId: z.string().uuid().nullable(),
  personName: z.string().nullable(),
  status: inviteStatusSchema,
  expiresAt: z.string().datetime(),
  createdAt: z.string().datetime(),
  /** Endereço para enviar a quem foi convidado. Só volta ao criar. */
  url: z.string().optional(),
});
export type Invite = z.infer<typeof inviteSchema>;

/** O que a pessoa vê antes de criar a conta. */
export const invitePreviewSchema = z.object({
  churchName: z.string(),
  name: z.string().nullable(),
  email: z.string(),
  roleName: z.string(),
});
export type InvitePreview = z.infer<typeof invitePreviewSchema>;

export const acceptInviteSchema = z.object({
  token: z.string().min(16),
  name: z.string().trim().min(3, 'Informe o seu nome').max(160),
  password: z
    .string()
    .min(10, 'A senha precisa de pelo menos 10 caracteres')
    .max(200),
});
export type AcceptInviteInput = z.infer<typeof acceptInviteSchema>;
